module.exports = __webpack_public_path__ + "media/images/tak_mil_splash_background-7b8589712af44ed0542dfa88ce5b96d2.jpg";